import React, {Children, useState} from "react";
import {Button} from "./buttons";
import ignoreEvent from "../helper/ignoreEvent";
import {Icon} from "./icon";
import useEffectExceptInitial from "../../../hooks/useEffectExceptInitial";

export function Dropdown({ buttonTypes, children, onChange, fullWidth = true, initialValue = null }) {
    /** @type ReactElement[] */
    const childrenArray = Children.toArray(children);

    if(childrenArray.length === 0) {
        throw new Error('empty dropdown is not allowed');
    }

    const firstChild = childrenArray[0];
    const [value, setValue] = useState(initialValue ?? firstChild.props.value);
    const currentChild = childrenArray.filter(child => child.props.value === value)[0];

    useEffectExceptInitial(
        () => setValue(initialValue ?? firstChild.props.value),
        [initialValue]
    )

    const displayValue = (currentChild ?? firstChild).props.children;

    function onChildChange(newValue) {
        setValue(newValue);
        onChange?.(newValue);
    }

    return <div className={'dropdown' + (fullWidth ? ' full-width' : '')}>
        <Button buttonTypes={buttonTypes} onClick={ignoreEvent} className={'dropdown-toggle'}>
            {displayValue}
            <div className={'d-inline-block ml-1'}><Icon type={'caret'} /></div>
        </Button>

        <ul className={'menu'}>
            {React.Children.map(children, child => React.cloneElement(child, { onClick: onChildChange }))}
        </ul>
    </div>;
}

export function DropdownElement({ value, onClick, children }) {
    return <li className={'menu-item'} onClick={onClick.bind(null, value)}><a onClick={ignoreEvent}>{children}</a></li>;
}
